// Write your code here
import Popup from 'reactjs-popup'
import CartItem from '../CartItem'
import CartContext from '../../context/CartContext'

import PaymentPopup from '../PaymentPopup'

import 'reactjs-popup/dist/index.css'

import './index.css'

const CartSummary = () => (
  <CartContext.Consumer>
    {value => {
      const {cartList} = value
      const cartItemsCount = cartList.length

      const getTotalAmount = () => {
        const totalAmount = cartList.reduce(
          (acc, item) => acc + item.quantity * item.price,
          0,
        )
        return totalAmount
      }

      return (
        <>
          <div className="summaryContainer">
            <h1>Order Total:{getTotalAmount()}</h1>
            <p>{cartItemsCount} Items in cart</p>
            <Popup
              className="popup-content"
              modal
              trigger={
                <button className="checkoutButton" type="button">
                  Checkout
                </button>
              }
            >
              {close => (
                <>
                  <div className="closeButtonContainer">
                    <button
                      type="button"
                      className="closeButton"
                      onClick={() => close()}
                    >
                      X
                    </button>
                  </div>
                  <div>
                    <h1>Order Total:{getTotalAmount()}</h1>
                    <p>{cartItemsCount} Items in cart</p>
                  </div>
                  <PaymentPopup />
                </>
              )}
            </Popup>
          </div>
        </>
      )
    }}
  </CartContext.Consumer>
)

export default CartSummary
